import(/* webpackMode: "eager" */ "/var/www/zamzam/web/src/app/global-error.tsx");
